export enum ErrorType {
  warning = 'warning',
  danger = 'danger'
}

export interface ErrorInfo {
  errorCode: string;
  container?: string;
  field?: string;
  errorMessage: string;
  status?: number;
  serviceName?: string;
  type?: ErrorType;
  serverMessage?: string;
  nextAvailableAt?: string;
  /**
   * Fields the backend's error envelope carries that this interface did not
   * declare. Services already read both when building a user-facing message —
   * `message` is the plain string, `errors` the class-validator list — so the
   * declaration was simply behind the wire format.
   *
   * Optional because not every failure path populates them: a transport error
   * has neither, and a thrown HttpException may carry only `message`.
   */
  message?: string;
  errors?: string[];
}

export function isErrorInfo(arg: any): arg is ErrorInfo {
  return arg && arg.errorMessage !== undefined;
}
